export default function Services() {
  const services = [
    {
      icon: 'ri-snowflake-line',
      title: 'AC Repair & Installation',
      description: 'Expert air conditioning repair and installation services for residential and commercial properties. We handle all makes and models with fast, reliable service to keep you cool all summer long.'
    },
    {
      icon: 'ri-fire-line',
      title: 'Heating System Service',
      description: 'Comprehensive heating solutions including boiler repair, furnace maintenance, and forced air heat systems. Stay warm and comfortable throughout the winter with our professional heating services.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Commercial HVAC Solutions',
      description: 'Full-service commercial HVAC installation, maintenance, and repair. We provide reliable solutions for businesses, ensuring optimal climate control and energy efficiency year-round.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-br from-orange-50/40 to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="text-xs font-light text-gray-500 uppercase tracking-wide mb-4">Our Expertise</div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
            Complete HVAC Solutions<br />
            <span className="font-light text-gray-600">For Every Season</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white/80 backdrop-blur-sm rounded-2xl p-12 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-8">
                <i className={`${service.icon} text-5xl text-gray-900`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-5">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#contact"
            className="inline-block bg-orange-600 text-white px-10 py-4 rounded-full text-base font-medium hover:bg-orange-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Request a Service
          </a>
        </div>
      </div>
    </section>
  );
}
